module.exports = __webpack_public_path__ + "img/banner3.7b317870.jpg";